<template>

    <div id="report-schedule">

        <div class="flex pt-6">
            <p class="flex-1 text-sm pr-4">
                Run reports automatically on a schedule, for example setup an order report to run weekly showing the last
                7 days sales. Once a schedule has run you will be emailed with the results, all completed schedules will be
                available under <a href="#" @click.prevent="showCompleteReports">completed reports</a>.
            </p>
        </div>

        <div class="py-6" v-if="loaded">

            <div class="grid grid-cols-4 gap-6" v-if="form.indexHasResults()">

                <a class="panel col-span-4 xl:col-span-1 cursor-pointer border-4 hover:border-brand-500" href="#"  v-for="(schedule) in form.index_data.data">
                    <div @click.prevent="editSchedule(schedule)">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-24 w-40 mx-auto text-gray-200" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false" role="img" :aria-label="schedule.name">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <h2 :id="schedule.name" class="font-medium text-gray-800">
                            {{ ellipsis(schedule.report_name, 32) }}
                        </h2>
                        <p class="text-sm text-gray-500">
                            {{ ellipsis(schedule.report_description, 40) }}
                        </p>
                        <p class="block status-box status-complete mt-2">
                            {{ schedule.frequency }}
                        </p>
                        <p class="block text-gray-600 text-sm font-normal mt-2">
                            {{ formatDateShort(schedule.created_at) }} by {{ schedule.user_name }}
                        </p>
                    </div>
                    <ConfirmationModal close_name="Cancel" confirm_name="Delete" @confirmModal="deleteSchedule(schedule.uuid)">
                        <template v-slot:clickable="{ toggleModal }">
                            <button class="btn-error text-sm w-full justify-center mt-4" @click="toggleModal">Delete Schedule</button>
                        </template>
                        <div class="text-gray-700">
                            <h2 class="font-bold text-lg mb-0">Delete Scheduled</h2>

                            <p class="mb-3 text-sm text-gray-600">
                                Are you sure you would like to delete the <span class="font-semibold">{{ schedule.report_name }}</span> schedule?
                                Doing so will prevent this report from being run automatically.
                            </p>
                        </div>
                    </ConfirmationModal>
                </a>

            </div>
            <div class="no-results panel" v-else>
                <div class="p-10">
                    <div class="text-gray-200 my-6">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false" role="img" aria-label="No Schedules Available">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>

                    <h2 class="text-gray-600 font-medium text-2xl text-center">No Report Schedules</h2>

                     <p class="text-center mt-4 text-sm text-gray-500">
                        You have not setup any report schedules, <a href="#" @click.prevent="createSchedule">create new schedule</a>.
                    </p>
                </div>
            </div>

        </div>
        <Loading message="Loading Pending Reports" v-else></Loading>

    </div>

</template>

<script>
import Loading from "../Support/Loading";
import {ReportSchedule} from "../../app/Report/ReportSchedule";
import ConfirmationModal from "../Support/ConfirmationModal";
import {FormattingMixin, PermissionMixin} from "../../support/mixins";

export default {
    name: "ReportSchedule",
    mixins: [PermissionMixin, FormattingMixin],
    components: {
        ConfirmationModal,
        Loading
    },
    data() {
        return {
            form: false,
            loaded: false,
        }
    },
    methods: {
        deleteSchedule(id) {
            let vm = this;

            vm.loaded = false;
            vm.form.page = 1;

            vm.form.deleteScheduledReport(id).then(r => {
                vm.form.index().then(r => {
                    vm.loaded = true;
                });
            }).catch(error => vm.handleError(error));
        },
        createSchedule() {
            this.$emit('createSchedule');
        },
        showCompleteReports() {
            this.$emit('showCompleteReports');
        },
        editSchedule(schedule) {
            this.$router.push({ name: 'report.schedule.edit', params: { schedule: schedule.uuid } });
        },
    },
    mounted() {
        let vm = this;

        new Promise(resolve => {
            vm.form = new ReportSchedule();

            vm.form.index().then(r => {
                resolve(true);
            });
        }).then(r => {
            vm.loaded = r;
        })
    }
}
</script>
